import { StudentDetails } from '@lx/quote-tool/shared/types';

export type LeadUserDataPayload = Pick<
  StudentDetails,
  | 'title'
  | 'firstName'
  | 'lastName'
  | 'email'
  | 'phoneNumber'
  | 'countryOfResidence'
  | 'leadType'
  | 'timeZone'
  | 'preferredClassTime'
  | 'websiteLanguage'
  | 'consentMarketing'
  | 'termsAndConditionsConsent'
>;
